/**
 * Phase F — Available (Not Arrived) variant.
 *
 * Buttons: Reserve (yellow) · Assign (green)
 * APIs:    POST /api/tables/{code}/reserve · /assign
 */
import { useState } from "react";
import DialogFieldGroup, {
  buildInitialValues,
  buildPayload,
} from "@/components/dialog/DialogFieldGroup";
import { useReserveTable, useAssignTable } from "@/hooks/useTableMutations";

export default function AvailableForm({ table, onClose }) {
  const [values, setValues] = useState(buildInitialValues(table));
  const reserve = useReserveTable();
  const assign = useAssignTable();

  const submitting = reserve.isPending || assign.isPending;

  const handleReserve = () => {
    const payload = buildPayload(values);
    reserve.mutate(
      { code: table.code, payload, version: table.version },
      { onSuccess: onClose },
    );
  };

  const handleAssign = () => {
    const payload = buildPayload(values, { includeComments: true });
    assign.mutate(
      { code: table.code, payload, version: table.version },
      { onSuccess: onClose },
    );
  };

  return (
    <>
      <DialogFieldGroup values={values} setValues={setValues} />

      <div
        className="flex justify-end gap-3 px-5 py-4 border-t"
        style={{ borderColor: "#E5E7EB" }}
      >
        <button
          data-testid="dlg-btn-reserve"
          onClick={handleReserve}
          disabled={submitting}
          className="px-5 py-2 rounded-md font-semibold text-sm disabled:opacity-50 transition-opacity"
          style={{ backgroundColor: "#F5C518", color: "#1A1A1A" }}
        >
          {reserve.isPending ? "Reserving…" : "Reserve"}
        </button>
        <button
          data-testid="dlg-btn-assign"
          onClick={handleAssign}
          disabled={submitting}
          className="px-5 py-2 rounded-md font-semibold text-sm text-white disabled:opacity-50 transition-opacity"
          style={{ backgroundColor: "#16A34A" }}
        >
          {assign.isPending ? "Assigning…" : "Assign"}
        </button>
      </div>
    </>
  );
}
